import { configureStore } from "@reduxjs/toolkit";
import ProjamAppSlice from "./Reducer/index";

export const Store = configureStore({
  reducer: {
    ProjamAppSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
